<div class="row">
  <div class="col-xs-12 col-12 col-sm-4 form-group">
    <input type="text" class="form-control" placeholder="Datepicker" #dp="bsDatepicker" bsDatepicker [bsConfig]="bsConfig">
  </div>
  <div class="col-xs-12 col-12 col-sm-8 form-group">
    <button class="btn btn-success" (click)="setOptions()" type="button">Set min date</button>
  </div>
</div>
